<template>
  <!-- SOCIAL -->
  <v-row>
    <v-col cols="12" md="6">
      <v-text-field
        prepend-inner-icon="mdi-web"
        label="website"
        v-model="websiteLocal"
        color="secondary"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field
        label="Facebook page"
        color="secondary"
        prepend-inner-icon="mdi-facebook"
        v-model="facebookLocal"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field
        label="instagram"
        prepend-inner-icon="mdi-instagram"
        color="secondary"
        v-model="instagramLocal"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field
        label="Youtube"
        prepend-inner-icon="mdi-youtube"
        color="secondary"
        v-model="youtubeLocal"
      />
    </v-col>
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    nameLocal: { required, minLength: minLength(5) },
    descriptionLocal: { minLength: minLength(10) }
  },
  props: ["facebook", "instagram", "website", "youtube"],
  methods: {
    isValide() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  },
  computed: {
    facebookLocal: {
      get() {
        return this.facebook;
      },
      set(value) {
        this.$emit("update:facebook", value);
      }
    },
    instagramLocal: {
      get() {
        return this.instagram;
      },
      set(value) {
        this.$emit("update:instagram", value);
      }
    },
    websiteLocal: {
      get() {
        return this.website;
      },
      set(value) {
        this.$emit("update:website", value);
      }
    },
    youtubeLocal: {
      get() {
        return this.youtube;
      },
      set(value) {
        this.$emit("update:youtube", value);
      }
    },
    // VALIDATION ERRORS
    nameErrors() {
      const errors = [];
      if (!this.$v.nameLocal.$dirty) return errors;
      !this.$v.nameLocal.minLength &&
        errors.push("Ce nécissite plus de 5 caractéres");
      !this.$v.nameLocal.required && errors.push("Ce champ est obligatoire.");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.descriptionLocal.$dirty) return errors;
      !this.$v.descriptionLocal.minLength &&
        errors.push("la description doit être 10 caractére au minimum.");
      return errors;
    }
  }
};
</script>